import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirming?: boolean;
  title?: string;
  description?: string;
}

export const DeleteEntryDialog = ({
  open,
  onClose,
  onConfirm,
  confirming = false,
  title = "Delete record",
  description = "This will permanently remove this record. This action cannot be undone.",
}: Props) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle sx={{ fontWeight: 850 }}>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{description}</DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2.5 }}>
      <Button onClick={onClose} color="inherit">
        Cancel
      </Button>
      <Button variant="contained" color="error" disabled={confirming} onClick={onConfirm}>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);
